<template>
  <div class="battery-add">
    <div class="row">
      <div class="label">优惠券名称</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="name" placeholder="请输入优惠券名称"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">适用组织</div>
      <div class="row-right">
        <el-cascader
          class="fixed-width-200"
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }" v-model="unitNo"
          clearable @change="getCommodity(unitNo[unitNo.length-1])"></el-cascader>
      </div>
    </div>
    <div class="row">
      <div class="label">适用商品</div>
      <div class="row-right">
        <el-select class="fixed-width-200"
                   clearable
                   v-model="commodityNo">
          <el-option
            v-for="item in commodityList"
            :key="item.number"
            :label="item.title"
            :value="item.number">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <table class="table-custom">
        <thead>
        <tr>
          <th width="120px">优惠券类型</th>
          <th width="200px">优惠内容</th>
          <th>优惠券数量</th>
          <!--          <th>每个用户领取次数</th>-->
          <th>生效条件</th>
          <th>同类优惠券<br/>使用关系</th>
          <th>不同类优惠券<br/>使用关系</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <el-radio-group v-model="type">
              <el-radio label="0">满减券</el-radio>
              <el-radio label="1">折扣券</el-radio>
              <el-radio label="2">满赠券</el-radio>
            </el-radio-group>
          </td>
          <td>
            <div v-if="type==0">
              <span style='line-height: 32px;'>订单满</span>
              <el-input class="fixed-width-50" v-model="attribute0"></el-input>
              <span>减</span>
              <el-input class="fixed-width-50" v-model="attribute1"></el-input>
            </div>
            <div v-if="type==1">
              <span style="line-height: 32px;">订单满</span>
              <el-input class="fixed-width-50" v-model="attribute0"></el-input>
              <span>打</span>
              <el-input class="fixed-width-50" v-model="attribute1"></el-input>
              <span>折</span>
            </div>
            <div v-if="type==2">
              <span style='line-height: 32px;'>订单满</span>
              <el-input class="fixed-width-50" v-model="attribute0"></el-input>
              <span>赠</span>
              <el-input class="fixed-width-50" v-model="attribute1"></el-input>
            </div>
          </td>
          <td>
            <el-radio-group class="fixed-width-75" v-model="quantityType" @change="quantityTypeChange">
              <el-radio label="0">无限制</el-radio>
              <el-radio label="1">数量</el-radio>
            </el-radio-group>
            <el-input class="fixed-width-50" v-model="totalQuantity" :disabled="quantityType==0"></el-input>
          </td>
          <!--          <td>-->
          <!--            <el-radio-group>-->
          <!--              <el-radio>无限制</el-radio>-->
          <!--              <el-radio>次数</el-radio>-->
          <!--            </el-radio-group>-->
          <!--            <el-input class="fixed-width-100"></el-input>-->
          <!--          </td>-->
          <td>
            <el-radio-group v-model="usePrequisite">
              <el-radio label="1">领取且激活后生效</el-radio>
              <el-radio label="0">领取后直接生效</el-radio>
            </el-radio-group>
          </td>
          <td>
            <el-radio-group v-model="similarUseRelation">
              <el-radio label="0">可叠加使用</el-radio>
              <el-radio label="1">不可叠加使用</el-radio>
            </el-radio-group>
          </td>
          <td>
            <el-radio-group v-model="noSimilarUseRelation">
              <el-radio label="0">可叠加使用</el-radio>
              <el-radio label="1">不可叠加使用</el-radio>
            </el-radio-group>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="label">使用说明</div>
      <div class="row-right">
        <el-input class="fixed-width-450" type="textarea" v-model="remark" :rows="3" placeholder="请输入使用说明"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">有效时间</div>
      <div class="row-right">
        <el-date-picker
          v-model="beginTime"
          class="date-global"
          size="mini"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="选择开始时间">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="endTime"
          size="mini"
          class="date-global"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="选择结束时间">
        </el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="label">状态</div>
      <div class="row-right">
        <el-select class="fixed-width-200" v-model="status">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  name: 'discountEditView',
  data() {
    return {
      number: '',
      name: '',
      unitList: [],
      unitNo: [],
      commodityList: [],
      commodityNo: '',
      type: '0',
      attribute0: '',
      attribute1: '',
      quantityType: '0',
      totalQuantity: '',
      usePrequisite: '1',
      similarUseRelation: '0',
      noSimilarUseRelation: '0',
      status: '0',
      statusList: [
        {
          id: '0',
          text: '上线'
        },
        {
          id: '1',
          text: '下线'
        }
      ],
      beginTime: '',
      endTime: '',
      remark: ''
    };
  },
  watch: {
    editData: {
      handler() {
        this.number = this.editData.number;
        this.name = this.editData.name;
        this.unitNo = this.editData.unitNo.split('[')[1].split(']')[0].split(',');
        this.getCommodity(this.unitNo[this.unitNo.length - 1]);
        this.commodityNo = this.editData.commodityNo;
        this.type = this.editData.type + '';
        this.attribute0 = JSON.parse(this.editData.content).attribute0;
        this.attribute1 = JSON.parse(this.editData.content).attribute1;
        this.quantityType = this.editData.totalQuantity ? '1' : '0';
        this.totalQuantity = this.editData.totalQuantity ? this.editData.totalQuantity : '';
        this.usePrequisite = this.editData.usePrequisite;
        this.similarUseRelation = this.editData.similarUseRelation ? this.editData.similarUseRelation : '';
        this.noSimilarUseRelation = this.editData.noSimilarUseRelation ? this.editData.noSimilarUseRelation : '';
        this.status = this.editData.statusCode + '';
        this.beginTime = new Date(this.editData.validBeginTime).getTime();
        this.endTime = new Date(this.editData.validEndTime).getTime();
        this.remark = this.editData.remark;
      },
      deep: true,
    },
  },
  mounted() {
    this.getUnitMember();
  },
  methods: {
    confirm() {
      this.addOrEditCoupons();
    },
    cancel() {
      this.$emit('cancel');
    },
    addOrEditCoupons() {
      let self = this;
      let content = {};
      content.attribute0 = this.attribute0;
      content.attribute1 = this.attribute1;
      let params = {
        number: this.number,
        commodityNo: this.commodityNo,
        type: this.type,
        unitNo: this.unitNo[this.unitNo.length - 1],
        usePrequisite: this.usePrequisite,
        content: JSON.stringify(content),
        totalQuantity: this.totalQuantity,
        similarUseRelation: this.similarUseRelation,
        noSimilarUseRelation: this.noSimilarUseRelation,
        status: this.status,
        name: this.name,
        validBeginTime: this.beginTime,
        validEndTime: this.endTime,
        remark: this.remark
      };
      this.$http.post('/managementPlatform/admin/addAndEditCoupons', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "编辑成功!",
          center: true
        });
        self.$emit('editSuccess');
      }).catch(function (response) {
        console.log(response);
      });
    },
    getUnitMember() {
      let self = this;
      this.$http.post('/managementPlatform/unit/queryManagedUnit'
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },
    getCommodity(value) {
      let self = this;
      let params = {
        unitNo: value
      }
      this.$http.post('/managementPlatform/admin/getCommodityForUnit', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.commodityList = res.ldata;
      }).catch(function (response) {
        console.log(response);
      });
    },
    quantityTypeChange() {
      if (this.quantityType == 0) {
        this.totalQuantity = '';
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 1080px;
  }

  .fixed-width-50 {
    width: 50px;
    vertical-align: top;
  }

  .fixed-width-75 {
    width: 75px;
    vertical-align: top;
  }

  .fixed-width-100 {
    width: 100px;
    vertical-align: top;
  }

  .fixed-width-150 {
    width: 150px;
    vertical-align: top;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>
<style>
.table-custom input.el-input__inner {
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/marketingMgmt/discountEditView.vue